import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';

interface ConfirmModalProps {
  show: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  buttonClass?: string;
  loading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({ show, title = 'Delete', message, onConfirm, onCancel, buttonClass = 'danger', loading = false }) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const bsModalRef = useRef<any>(null);

  useEffect(() => {
    if (modalRef.current && !bsModalRef.current) {
      bsModalRef.current = new (window as any).bootstrap.Modal(modalRef.current, {
        backdrop: 'static',
        keyboard: false,
      });
    }

    if (bsModalRef.current) {
      show ? bsModalRef.current.show() : bsModalRef.current.hide();
    }
  }, [show]);

  const handleClose = () => {
    if (bsModalRef.current) {
      bsModalRef.current.hide();
    }
    onCancel();
  };

  return (
    <div className="modal fade" tabIndex={-1} ref={modalRef} aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <p>{message}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={handleClose}
              disabled={loading}>
              {t('Cancel')}
            </button>
            <button className={`btn btn-${buttonClass}`} onClick={onConfirm}
              disabled={loading}>
              {t(title)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
